module.exports = __webpack_public_path__ + "img/BlinkArt_Sword8_Corrupted.5b0586ab.png";